import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "../common/common.scss";
import CloseIcon from "../../Assets/Icons/CloseIconSvg.svg";

const DetailsModal = ({
  handleClose,
  content,
  popupClassName,
  continueBtn,
  cancelBtn,
}) => {
  const CLOSE_ANIMATION_MS = 220;
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      setIsVisible(true);
    });

    return () => {
      window.cancelAnimationFrame(frameId);
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
      }
    };
  }, []);

  const runCloseAnimation = () => {
    if (isClosing) return;

    setIsClosing(true);
    setIsVisible(false);
    closeTimerRef.current = setTimeout(() => {
      handleClose?.();
    }, CLOSE_ANIMATION_MS);
  };

  return createPortal(
    <div
      className={`popup-container details-modal-backdrop ${
        isVisible && !isClosing
          ? "details-modal-backdrop-enter"
          : "details-modal-backdrop-exit"
      }`}
      onClick={runCloseAnimation}
    >
      <div
        className={`popup details-modal-panel flex flex-col items-center bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] relative ${
          isVisible && !isClosing
            ? "details-modal-panel-enter"
            : "details-modal-panel-exit"
        } ${popupClassName}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="h-[3%]">
          <button
            type="button"
            aria-label="Close modal"
            className={`absolute -top-6 -right-6 w-[35px] h-[35px] flex items-center justify-center cursor-pointer transition-transform duration-200 hover:scale-105 ${
              isClosing ? "pointer-events-none" : ""
            }`}
            onClick={runCloseAnimation}
          >
            <img
              src={CloseIcon}
              alt="Close"
              className="block w-full h-full object-contain"
            />
          </button>
        </div>
        <div className="text-[14px] sm:text-[16px] font-[400] font-montserrat text-[#303030] text-center break-words w-[95%]">
          {content}
        </div>
        {!cancelBtn ? (
          continueBtn
        ) : (
          <div className="w-full flex justify-center items-center gap-4">
            {cancelBtn}
            {continueBtn}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default DetailsModal;
